import { Modal } from 'react-bootstrap'

const UserRefundLimitModal = ({
  showModal,
  closeModal,
  saving,
  isRefundLimitEnabled,
  newLimitAmount,
  setNewLimitAmount,
  currentMonthData
}) => {
  const handleConfirm = () => {
    closeModal(true)
  }

  const handleCancel = () => {
    if (!saving) {
      closeModal(false)
    }
  }

  const handleLimitChange = (event) => {
    event.preventDefault()
    let value = event.target.value
    const regex = /^\d*(\.\d{0,2})?$/

    if (!regex.test(value)) {
      event.target.value = value.slice(0, -1)
    }
    setNewLimitAmount(event.target.value)
  }

  const isNewLimitValid = () => {
    if (newLimitAmount == null || newLimitAmount < 0) {
      return false
    }

    if (isRefundLimitEnabled && currentMonthData) {
      return Number(newLimitAmount) >= Number(currentMonthData.used_amount)
    }

    return true
  }

  return (
    <div>
      <Modal
        onHide={handleCancel}
        backdrop="static"
        keyboard={false}
        size="lg"
        show={showModal}
        className="button-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="title-grey-icon ">
              <b className="unavailable-modal-title">
                {isRefundLimitEnabled
                  ? 'Editar máximo de devoluciones'
                  : 'Habilitar máximo de devoluciones'}
              </b>
            </p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: '20px' }}>
          <div>
            <div className="container-fluid modal-container">
              <div className="form-row">
                <p>
                  {isRefundLimitEnabled
                    ? 'El monto usado acumulado se mantiene. El nuevo valor aplica de inmediato como máximo del mes en curso.'
                    : 'Defina el monto mensual permitido para devoluciones de este usuario. Es un límite recurrente que se reinicia automáticamente el 1 de cada mes.'}
                </p>
              </div>
              {isRefundLimitEnabled && (
                <div className="form-row">
                  <p>
                    <span className="mb-15 refund-limit-modal-bold">
                      {`Máximo actual: $${Number(currentMonthData?.current_amount).toFixed(2)}`}
                    </span>
                  </p>
                </div>
              )}

              <div className="form-row">
                <p>
                  <span className="mb-20 assign-document-modal-bold">
                    {isRefundLimitEnabled ? 'Nuevo monto mensual:' : 'Monto mensual:'}
                  </span>
                </p>
                <input
                  type="number"
                  id="limit_amount"
                  onChange={handleLimitChange}
                  className="form-control client-form-input-width"
                  required
                  value={newLimitAmount}
                  placeholder="$0.00"
                  step="1.00"
                  min="0"
                />
                {newLimitAmount == 0.0 && (
                  <p className="ft-12 mt-10 flex-align-center">
                    <svg
                      width="19"
                      height="16"
                      viewBox="0 0 19 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="warning-route-plan-icon"
                    >
                      <path
                        d="M9.16667 0.166992L0 16.0003H18.3333L9.16667 0.166992Z"
                        fill="#FEC047"
                      />
                      <path
                        d="M9.16563 3.49219L15.4406 14.3339H2.89062L9.16563 3.49219Z"
                        fill="#FEC047"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.33398 6.83398H10.0007V10.1673H8.33398V6.83398ZM8.33398 11.834H10.0007V13.5007H8.33398V11.834Z"
                        fill="#202020"
                      />
                    </svg>
                    <span className="ft-12">
                      Este usuario no podrá registrar devoluciones en la app mientras su máximo
                      mensual sea <span className="ft-12 font-weight-600">$0.00</span>
                    </span>
                  </p>
                )}
                {currentMonthData != null &&
                  newLimitAmount != null &&
                  newLimitAmount < Number(currentMonthData?.used_amount) && (
                    <p className="ft-12 mt-10 flex-align-center">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g mask="url(#mask0_16875_7844)">
                          <path
                            d="M8.00065 11.3333C8.18954 11.3333 8.34787 11.2694 8.47565 11.1417C8.60343 11.0139 8.66732 10.8555 8.66732 10.6667C8.66732 10.4778 8.60343 10.3194 8.47565 10.1917C8.34787 10.0639 8.18954 9.99999 8.00065 9.99999C7.81176 9.99999 7.65343 10.0639 7.52565 10.1917C7.39787 10.3194 7.33398 10.4778 7.33398 10.6667C7.33398 10.8555 7.39787 11.0139 7.52565 11.1417C7.65343 11.2694 7.81176 11.3333 8.00065 11.3333ZM7.33398 8.66666H8.66732V4.66666H7.33398V8.66666ZM8.00065 14.6667C7.07843 14.6667 6.21176 14.4917 5.40065 14.1417C4.58954 13.7917 3.88398 13.3167 3.28398 12.7167C2.68398 12.1167 2.20898 11.4111 1.85898 10.6C1.50898 9.78888 1.33398 8.92222 1.33398 7.99999C1.33398 7.07777 1.50898 6.21111 1.85898 5.39999C2.20898 4.58888 2.68398 3.88333 3.28398 3.28333C3.88398 2.68333 4.58954 2.20833 5.40065 1.85833C6.21176 1.50833 7.07843 1.33333 8.00065 1.33333C8.92287 1.33333 9.78954 1.50833 10.6007 1.85833C11.4118 2.20833 12.1173 2.68333 12.7173 3.28333C13.3173 3.88333 13.7923 4.58888 14.1423 5.39999C14.4923 6.21111 14.6673 7.07777 14.6673 7.99999C14.6673 8.92222 14.4923 9.78888 14.1423 10.6C13.7923 11.4111 13.3173 12.1167 12.7173 12.7167C12.1173 13.3167 11.4118 13.7917 10.6007 14.1417C9.78954 14.4917 8.92287 14.6667 8.00065 14.6667ZM8.00065 13.3333C9.48954 13.3333 10.7507 12.8167 11.784 11.7833C12.8173 10.75 13.334 9.48888 13.334 7.99999C13.334 6.51111 12.8173 5.24999 11.784 4.21666C10.7507 3.18333 9.48954 2.66666 8.00065 2.66666C6.51176 2.66666 5.25065 3.18333 4.21732 4.21666C3.18398 5.24999 2.66732 6.51111 2.66732 7.99999C2.66732 9.48888 3.18398 10.75 4.21732 11.7833C5.25065 12.8167 6.51176 13.3333 8.00065 13.3333Z"
                            fill="#FF4343"
                          />
                        </g>
                      </svg>
                      <span className="ft-12">
                        El nuevo monto asignado es menor que lo acumulado del mes{' '}
                        <span className="ft-12 font-weight-600">{`$${currentMonthData?.used_amount}`}</span>
                        . Ingresa un máximo mayor.
                      </span>
                    </p>
                  )}
              </div>
              <br />
              <div className="form-group">
                <div className="check-modal-user d-flex align-items-center"></div>
                <div className="float-right mt-3">
                  <button
                    onClick={handleCancel}
                    className="btn cancel-modal-button"
                    disabled={saving}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleConfirm}
                    className={`btn float-right ${!isNewLimitValid() ? 'blue-disabled-modal-button' : 'blue-modal-button'}`}
                    disabled={saving || !isNewLimitValid()}
                  >
                    {isRefundLimitEnabled ? 'Actualizar' : 'Habilitar'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default UserRefundLimitModal
